import {
  FullStory,
  init,
  isInitialized as isFullStoryInitialized,
} from "@fullstory/browser"
import { config } from "~/lib/config"

export const ensureFullstoryInitialized = (onReady?: () => void): void => {
  if (isFullStoryInitialized()) {
    onReady?.()
    return
  }
  init({ orgId: "o-1XWVRD-na1", debug: config.env.isDevelopment }, onReady)
}

const setFullStoryIdentity = (
  id: string | null,
  displayName: string,
  email: string
) => {
  if (id) {
    FullStory("setIdentity", {
      uid: id,
      properties: {
        displayName,
        email,
      },
    })
  } else {
    // Clear identity on logout - starts a new anonymous session
    FullStory("setIdentity", { anonymous: true })
  }
}

export const setFullStoryUser = (
  id: string | null,
  displayName: string,
  email: string
) => {
  ensureFullstoryInitialized(() => {
    setFullStoryIdentity(id, displayName, email)
  })
}
